export default __webpack_public_path__ + "static/zaru_collages_v6-5-695ac8be61218d88d512414979038207.png";